import React, { useEffect, useState } from "react"
import { View, StyleSheet, Text, ScrollView, Dimensions, TouchableOpacity, Alert, Image } from "react-native"
import { Button } from "@Components/CustomButton/Button"
import { ContainerGlogal } from "@Components/ContainerGlogal"
import { InputGroup } from "@Components/Input/InputGroups"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors } from "@Constants/baseStyles"
import { LoginService } from "@Services/Login.Service"
import { Ionicons } from "@expo/vector-icons"
import { LocalStorage } from "@Services/sharedPreferences/localStorage"
import { useRecoilState, useSetRecoilState } from "recoil"
import { userAtom } from "@Recoil/Atom/userAtom"
import { UserService } from "@Services/User.service"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import CustomCheckBox from "@Components/CustomCheckBox/CustomCheckBox"
import { CustomRadio } from "@Components/CustomRadio/CustomRadio"
import { TextInputMask } from "react-native-masked-text"
import { Avatar, Divider } from "react-native-paper"
import moment from "moment"
import { dbDateFormat, localDateFormat, validDate } from "@Utils/utils"
import * as ImagePicker from "expo-image-picker"
// import RNFS from "react-native-fs"
import { useRoute } from "@react-navigation/native"

const defaultpasswords = {
    oldPassword: "",
    password: "",
    retypePassword: ""
}

const avatar = require("@assets/icons/profile.png")

export const Profile = ({ navigation }) => {
    const [loading, setLoading] = useState(false)
    const [hasError, setHasError] = useState(false)
    const [passwords, setPasswords] = useState(defaultpasswords)
    const [user, setUser] = useRecoilState(userAtom)
    const [image, setImage] = useState(null)
    const [userProfile, setUserProfile] = useState(null)
    const route = useRoute()
    const userProfileImg = route?.params?.userProfileImg

    const pickImage = async () => {
        // No permissions request is necessary for launching the image library
        let result = await ImagePicker.launchImageLibraryAsync({
            mediaTypes: ImagePicker.MediaTypeOptions.All,
            allowsEditing: true,
            aspect: [4, 3],
            quality: 1
        })

        //base64 res
        let base64Image = ""
        // await RNFS.readFile(result.assets[0].uri, "base64").then((res) => {
        //     return res
        // })

        if (base64Image) {
            setUserProfile(`data:image/jpeg;base64,${base64Image}`)
        }

        if (!result?.assets?.canceled) {
            setImage(result.assets[0].uri)
        }
    }

    const canSubmitPersonnalData = () => {
        return (
            user.lastName.length > 0 &&
            user.firstName.length > 0 &&
            (user?.birthDate?.length === 10 && user?.birthDate ? validDate(user.birthDate) : true)
        )
    }

    const userBirthDate = user?.birthDate
        ? moment(user.birthDate, dbDateFormat).format(localDateFormat)
        : moment(new Date(), dbDateFormat).format(localDateFormat)

    useEffect(() => {
        if (user && user?.birthDate) {
            setUser((old) => ({
                ...old,
                birthDate: userBirthDate
            }))
        }
    }, [userBirthDate])

    const payload = {
        firstName: user?.firstName,
        lastName: user?.lastName,
        filecontent: userProfile
    }

    const performUpdatePersonalData = () => {
        setLoading(true)

        console.log({ payload })

        UserService.updateUserData(user.id, payload)
            .then((response) => {
                setLoading(false)
                ShowToast({ type: "success", message: "vos informations ont été enregistrées" })
            })
            .catch((err) => {
                console.log(err.message)
                ShowToast({ type: "error", message: "oops, une erreur est survenue" })
                setLoading(false)
            })
    }

    const RenderAvatarForm = () => {
        return (
            <>
                <BreeSerifText
                    style={{ textAlign: "left", fontSize: 20, color: baseColors.green.primary, paddingTop: 10 }}
                >
                    Modifier mon avatar
                </BreeSerifText>
                <OpenSansText>Cliquez sur votre avatar pour le modifer.</OpenSansText>
                <View
                    style={{
                        marginTop: 30,
                        justifyContent: "center",
                        display: "flex",
                        alignContent: "center",
                        alignItems: "center"
                    }}
                >
                    <TouchableOpacity onPress={pickImage}>
                        <Image
                            source={image ? { uri: image } : userProfileImg ? { uri: userProfileImg ?? "" } : avatar}
                            height={35}
                            width={35}
                            style={{ height: 100, width: 100, borderRadius: 50 }}
                        />
                    </TouchableOpacity>
                </View>
            </>
        )
    }

    const RenderNameForm = () => {
        return (
            <>
                <BreeSerifText
                    style={{ textAlign: "left", fontSize: 20, color: baseColors.green.primary, paddingTop: 40 }}
                >
                    Modifier mon nom
                </BreeSerifText>
                <OpenSansText>Cliquez sur les champs pour éditer les noms.</OpenSansText>
                <View style={{ marginTop: 30 }}>
                    <InputGroup
                        disabled={loading}
                        onChange={(text) => {
                            setUser((old) => ({ ...old, firstName: text }))
                        }}
                        valid={user.firstName.length > 0}
                        value={user.firstName}
                        validation_message={"obligatoire"}
                        label={"Nom"}
                        placeholder={"Entrez votre nom"}
                    />
                    <InputGroup
                        disabled={loading}
                        onChange={(text) => {
                            setUser((old) => ({ ...old, lastName: text }))
                        }}
                        valid={user.lastName.length > 0}
                        value={user.lastName}
                        validation_message={"obligatoire"}
                        label={"Prénom"}
                        placeholder={"Entrez votre prénom"}
                    />
                    {/* <View style={{ display: "flex", flexDirection: "row", marginTop: 10, marginBottom: 20 }}>
                        <CustomRadio
                            label={"Homme"}
                            value={1}
                            checked={user.sex === 1}
                            setValue={(value) => {
                                setUser((old) => ({ ...old, sex: value }))
                            }}
                        ></CustomRadio>
                        <View style={{ width: 40 }}></View>
                        <CustomRadio
                            label={"Femme"}
                            checked={user.sex === 0}
                            value={0}
                            setValue={(value) => {
                                setUser((old) => ({ ...old, sex: value }))
                            }}
                        ></CustomRadio>
                    </View>
                    <InputGroup
                        mask={"datetime"}
                        disabled={loading}
                        onChange={(text) => {
                            setUser((old) => ({ ...old, birthDate: text }))
                        }}
                        valid={user?.birthDate ? validDate(user.birthDate) : true}
                        value={user?.birthDate ? user.birthDate : moment(new Date()).format(localDateFormat)}
                        validation_message={"Date invalide"}
                        maxLength={10}
                        label={"Date de naissance"}
                        placeholder={"12/03/1998"}
                    />
                    <InputGroup
                        disabled={loading}
                        onChange={(text) => {
                            setUser((old) => ({ ...old, birthPlace: text }))
                        }}
                        valid={true}
                        value={user.birthPlace}
                        validation_message={""}
                        label={"Lieu de naissance"}
                        placeholder={"Entrez votre lieu de naissance"}
                    />
                    <InputGroup
                        disabled={loading}
                        onChange={(text) => {
                            setUser((old) => ({ ...old, phoneNumber: text }))
                        }}
                        valid={true}
                        value={user.phoneNumber}
                        validation_message={""}
                        label={"Téléphone"}
                        placeholder={"Entrez votre téléphone"}
                    />
                    <InputGroup
                        disabled={loading}
                        onChange={(text) => {
                            setUser((old) => ({ ...old, civility: text }))
                        }}
                        valid={true}
                        value={user.civility}
                        validation_message={""}
                        label={"Civilité"}
                        placeholder={"Français"}
                    />
                    <InputGroup
                        disabled={loading}
                        onChange={(text) => {
                            setUser((old) => ({ ...old, height: text }))
                        }}
                        valid={true}
                        value={user?.height?.toString()}
                        validation_message={""}
                        label={"Taille en cm"}
                        placeholder={"185 cm"}
                    />

                    <InputGroup
                        disabled={loading}
                        onChange={(text) => {
                            setUser((old) => ({ ...old, weight: text }))
                        }}
                        valid={true}
                        value={user?.weight?.toString()}
                        validation_message={""}
                        label={"Poids en kg"}
                        placeholder={"80 kg"}
                    />

                    <InputGroup
                        disabled={loading}
                        onChange={(text) => {
                            setUser((old) => ({ ...old, address: text }))
                        }}
                        valid={true}
                        value={user.address}
                        validation_message={""}
                        label={"Adresse"}
                        placeholder={"15 rue des ..."}
                    />
                    <InputGroup
                        disabled={loading}
                        onChange={(text) => {
                            setUser((old) => ({ ...old, profession: text }))
                        }}
                        valid={true}
                        value={user.profession}
                        validation_message={""}
                        label={"Profession"}
                        placeholder={"Enseignant"}
                    /> */}
                </View>
                <Button
                    disabled={!canSubmitPersonnalData() || loading}
                    loading={loading}
                    onPress={performUpdatePersonalData}
                    text="sauvegarder"
                    width="80%"
                    height={45}
                    backgroundColor={baseColors.green.primary}
                    labelColor={"white"}
                />
                <Divider style={{ height: 1, marginTop: 20, marginBottom: 5 }} />
            </>
        )
    }

    return (
        <ContainerGlogal style={{ paddingTop: 10 }}>
            <ScrollView keyboardShouldPersistTaps={"handled"} contentContainerStyle={{ paddingBottom: 80 }}>
                <View style={styles.container}>
                    {RenderAvatarForm()}
                    {RenderNameForm()}
                </View>
            </ScrollView>
        </ContainerGlogal>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        paddingTop: 0,
        paddingHorizontal: 20,
        backgroundColor: "white",
        alignContent: "center"
    },
    text: {
        color: baseColors.black,
        textAlign: "justify",
        fontFamily: "BreeSerif",
        fontSize: 16
    }
})
